import Routing from 'utils/router';
import Security from 'utils/security';
import EscapeHtml from 'utils/escape-html';
import moment from 'moment';
import confirmationDialogs from 'tap-confirmation-dialogs';

module.exports.kbPreAppendItem = function($item, hit) {
    var description = hit._snippetResult.description.value
                                                    .replace("<em>","||em||")
                                                    .replace("</em>","||/em||")
                                                    .replace(/(<([^>]+)>)/ig,"")
                                                    .replace("||em||", "<em>")
                                                    .replace("||/em||", "</em>");
    $item.append(`<div class="search-suggestion">
                    <div class="search-suggestion-title"><a href="https://tapfiliate.com/knowledge-base/articles/${hit.slug}/">${hit.internal ? '<span class="badge badge-default">internal</span>' : ''} ${hit._highlightResult.title.value}</a></div>
                    <div class="search-suggestion-body">${description}</div>
                  </div>`);

}

module.exports.kbPreAppendNoResultsItem = function($item) {
    module.exports.preAppendNoResultsItem($item);
}

module.exports.preAppendNoResultsItem = function($item) {
    $item.html('<div class="search-suggestion search-suggestion-empty">' +
                    '<div class="search-suggestion-body">No results&hellip;</div>' +
                '</div>');
};

function getProgramCounts(hit, programSlugs) {
    var counts = {
        pending: 0,
        disapproved: 0,
        approved: 0,
    };

    for (var i = hit._tags.length - 1; i >= 0; i--) {
        var tag = hit._tags[i];

        var matches = tag.match(/pro_([^_]*)_(.*)/);
        if (!matches) continue;

        var slug = matches[1];
        if (!slug || programSlugs.indexOf(slug) === -1) continue;

        var status = matches[2];
        if (!status || ["pending", "disapproved", "approved"].indexOf(status) === -1) continue;

        counts[status]++;
    }

    return counts;
}

module.exports.affiliatesPreAppendItem = function($item, hit, archive, programSlugs, csrf) {
    var showUrl = Routing.generate('tap_publishing_frontend_ai_affiliate_redirectusernametouuid', {'slug': hit.slug})
    var fullname = EscapeHtml(hit.firstname + ' ' + hit.lastname);
    var company = EscapeHtml(hit.company_title) || '-';

    var counts = getProgramCounts(hit, programSlugs);

    var row = '<td><a href="' + showUrl + '">' + fullname + '</a></td>' +
                '<td>' + company + '</td>' +
                '<td>' + moment(hit.created_at).fromNow() + '</td>' +
                '<td class="pending-count">' + counts.pending + '</td>' +
                '<td class="disapproved-count">' + counts.disapproved + '</td>' +
                '<td class="approved-count">' + counts.approved + '</td>';

    if (!archive) {
        var allDisapproved = counts.pending === 0 && counts.approved === 0;
        var allApproved = counts.pending === 0 && counts.disapproved === 0;

        var disapproveButton = `<button class="c-button-group__button disapprove-publisher with-confirmation c-button-group__button--reject${ allDisapproved ? " c-button-group__button--selected" : ""}" data-message="This will disapprove the affiliate for <strong>all programs</strong>." data-slug="${hit.slug}" ${(!Security.isGranted('ROLE_CR_AFFILIATE_MANAGER') ? ' disabled' : '')}>Disapprove${allDisapproved ? "d" : ""}</button>`;

        var approveButton = `<button class="c-button-group__button approve-publisher with-confirmation c-button-group__button--accept${ allApproved ? " c-button-group__button--selected" : ""}"" data-message="This will approve the affiliate for the following programs:<ul>{% for affiliation in affiliate.pendingPrograms %}<li>{{ affiliation.program.title }}</li>{% endfor %}{% for affiliation in affiliate.disapprovedPrograms %}<li>{{ affiliation.program.title }}</li>{% endfor %}</ul>" data-slug="${hit.slug}" ${(!Security.isGranted('ROLE_CR_AFFILIATE_MANAGER') ? ' disabled' : '')}>Approve${allApproved ? "d" : ""}</button>`;

        row += `<td><div class="c-button-group">${approveButton}${disapproveButton}</div></td>`;
    } else {
        row += `<td>
                    <form class="di" action="${Routing.generate('tap_publishing_frontend_ai_affiliate_delete_deprecated', {'usernameCanonical': hit.slug}) }" method="post">
                        <input type="hidden" name="_csrf_token" value="${csrf}">
                        <button class="btn btn-danger btn-fill confirmation" type="submit" data-message="This will delete all the affiliate's data. Payouts and commissions will be kept." data-confirmation-phrase="${fullname}" data-confirmation-form-submit="true" ${(!Security.isGranted('ROLE_CR_AFFILIATE_MANAGER') ? ' disabled' : '')}><span class="tapicon tapicon-delete"></span> Delete affiliate</button>
                    </form>
                </td>
                `;
    }

    $item.html(row);
};

function affiliateIsApproved(hit, programSlug) {
    for (var i = hit._tags.length - 1; i >= 0; i--) {
        var tag = hit._tags[i];

        if (tag.indexOf(programSlug)) {
            var matches = tag.match(/pro_([^_]*)_(.*)/);
            if (!matches) continue;

            var status = matches[2];

            if (status === "approved") return true;
        }
    }
}

module.exports.programAffiliatesPreAppendItem = function($item, hit, archive, programSlug) {
    var showUrl = Routing.generate('tap_publishing_frontend_ai_affiliate_redirectusernametouuid', {'slug': hit.slug});
    var fullname = EscapeHtml(hit.firstname + ' ' + hit.lastname);
    var company = EscapeHtml(hit.company_title) || '-';

    var approvalRowContent = '';
    if (!affiliateIsApproved(hit, programSlug)) {
        if (!archive) {
            approvalRowContent += '<button class="btn btn-warning disapprove-affiliate" data-username="' + hit.slug + '" data-slug="' + programSlug + '"' + (!Security.isGranted('ROLE_CR_AFFILIATE_MANAGER') ? ' disabled' : '') + '>Disapprove</button>';
        }

        approvalRowContent += '<button class="btn btn-success approve-affiliate" data-username="' + hit.slug + '" data-slug="' + programSlug + '"' + (!Security.isGranted('ROLE_CR_AFFILIATE_MANAGER') ? ' disabled' : '') + '>Approve</button>';
    } else {
        approvalRowContent += '<span class="tapicon tapicon-check"></span>';
    }

    var row = '<td><a href="' + showUrl + '">' + fullname + '</a></td>' +
            '<td>' + company + '</td>' +
            '<td>' + approvalRowContent + '</td>';

    if (!archive) {
        row += '<td><div class="referral-link-holder"><input class="form-control referral-link input-sm select-on-click" type="text" value="" readonly><div class="spinner-holder p-a input-spinner input-spinner-transparent"></div></div></td>';
        row += '<td><button class="btn btn-danger remove-affiliate with-confirmation" data-username="' + hit.slug + '" data-slug="' + programSlug + '" data-message="This will remove the affiliate from this program. Removed affiliates can be re-approved in the archive section" ' + ((!Security.isGranted('ROLE_CR_AFFILIATE_MANAGER') || !affiliateIsApproved(hit, programSlug)) ? ' disabled' : '') + '><span class="tapicon tapicon-delete"></span></button></td>';
    }

    $item.html(row);
    $item.data('affiliate-id', hit.slug);
};

module.exports.programAffiliatesLoadReferralLinks = function(programSlug, csrf) {
    $('.search-results tr').each(function(){
        var affiliateId = $(this).data('affiliate-id');

        if (!affiliateId) return;

        var $referralLinkEl = $(this).find('.referral-link');

        if (!$referralLinkEl.size()) return;

        var self = this;
        var showAffiliateRoute = Routing.generate('tap_program_api_pub_ai_program_showaffiliate_stateful', {username: affiliateId, slug: programSlug});

        $.ajax({
            url: showAffiliateRoute,
            headers: {
              "X-Csrf-Token": csrf
            },
            success: function(res){
                var link = res.referral_link.link;
                if (!link) return;

                $referralLinkEl.val(link);
                $(self).find('.spinner-holder').remove();
            }
        });
    });
};

module.exports.affiliatesPostSearch = function(err, result) {
    $('.original-results, .pagination-footer').hide();
    $('.export-button').prop('disabled', true);
    confirmationDialogs.setup();
};

module.exports.affiliatesPostRemoveQuery = function() {
    $('.search-results').hide();
    $('.original-results, .pagination-footer').show();
    $('.export-button').prop('disabled', false);
    confirmationDialogs.setup();
};

module.exports.affiliatesPreAppendNoResultsItem = function($item) {
    $item.html('<td colspan="9">No results&hellip;</td>');
};
